/**
 * How the profile page reads a user's membership.
 *
 * The backend's `subscriptionStatus` vocabulary is "active", "canceling",
 * "canceled", "complimentary", "none", or a raw Stripe status for anything
 * unusual. Premium is the boolean that matters; the status only shapes the
 * copy. This used to require "active" or "canceling" specifically, which was
 * written before complimentary memberships existed (#208) and rendered a
 * comped member as "Free User" with no state picker (#232). AuthContext's
 * isPremium has always been `premium && status !== "canceled"`; this agrees.
 */
export const describeSubscription = (user, subscriptionStatus) => {
    const status = subscriptionStatus || user?.subscriptionStatus || null;
    const isPremiumActive = Boolean(user?.premium) && status !== 'canceled';
    const isCanceling = isPremiumActive && status === 'canceling';
    const isComplimentary = isPremiumActive && status === 'complimentary';

    let expiryLabel = 'Renews';
    if (isCanceling) {
        expiryLabel = 'Premium access ends';
    } else if (isComplimentary) {
        expiryLabel = 'Complimentary access through';
    }

    return {
        isPremiumActive,
        isCanceling,
        isComplimentary,
        // A complimentary grant has no Stripe subscription behind it, so
        // there is nothing to cancel or resume.
        canManageSubscription: isPremiumActive && !isComplimentary,
        expiryLabel
    };
};
